// API keys and configuration
export const GOOGLE_SPEECH_API_KEY = "AIzaSyB7Hg1BRNApZKKvFode_gqu-4wSoNDrdb0";

// API endpoints
export const GOOGLE_SPEECH_API_ENDPOINT = "https://speech.googleapis.com/v1/speech:recognize";

// API configurations
export const SPEECH_CONFIG = {
  encoding: "WEBM_OPUS",
  sampleRateHertz: 48000,
  languageCode: "en-US"
}; 